import { animated, config, useSpring } from "@react-spring/web";
import { useState } from "react";
import { Waypoint } from "react-waypoint";
import styles from "../css/offers.module.css";

function UnderlineT({ width = "50px" }) {
  const [open, toggleOpen] = useState(false);

  const props = useSpring({
    width: open ? width : "0px",
    backgroundColor: open ? "#3A959B" : "white",
    delay: 200,
    config: config.wobbly,
  });
  return (
    <>
      <Waypoint bottomOffset="20%" onEnter={() => toggleOpen(true)} />
      <animated.div className={styles.fill} style={props}></animated.div>
    </>
  );
}

export default UnderlineT;
